import { render, staticRenderFns } from "./not-clothing.vue?vue&type=template&id=33ec3e7a"
import script from "./not-clothing.vue?vue&type=script&lang=ts"
export * from "./not-clothing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports